import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { API_BOOKING, API_FETCH_BOOKINGS } from 'src/@core/services/util/api.endpoints';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { Lightbox, LightboxConfig, IAlbum } from 'ngx-lightbox'; // Import Lightbox and LightboxConfig
import { AppService } from 'src/@core/services/app.service';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators, ValidatorFn } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
// import { BookSocietyDialogComponent } from '../book-booking-dialog/book-booking-dialog.component';
import { environment } from 'src/environments/environment';
import { ViewUploadedImageComponent } from '../../employment/view-proof-of-work/view-uploaded-image/view-uploaded-image.component';
import { NotificationService } from 'src/@core/services/notification.service';
import { RequestQuoteComponent } from '../request-quote/request-quote.component';

declare var Razorpay: any;

@Component({
  selector: 'hour4u-admin-view-booking',
  templateUrl: './view-booking.component.html',
  styleUrls: ['./view-booking.component.scss']
})
export class ViewBookingComponent implements OnInit {

  societies: any[] = [];
  booking: any;
  timeDifference: string = '';
  tiles: any[] = [];
  bookingId: string;
  baseImageUrl = environment.image_url
  imageUrls: string[] = []; // property to store image URLs
  albums: IAlbum[] = [];

  roles = roles;
  entityTypes = entityTypes;
  currentUserRole: any = null;
  public userEmail: string = '';
  form: FormGroup;
  numberOfHours: any;
  copiedSocieties: { [key: string]: boolean } = {};
  copyTitleSociety: string = 'Share';
  bookedSocieties: any[] = [];
  serviceAdded: boolean = false;
  isSubmitted: boolean = false;
  loaderColor: string;
  mode = 'indeterminate';
  isLoading: boolean = true;
  profile = this.appService.getCurrentAccount();

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private lightbox: Lightbox,
    private lightboxConfig: LightboxConfig,
    private appService: AppService,
    private router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private notify: NotificationService
  ) {

  }

  ngOnInit(): void {
    // Retrieve the booking ID from the route parameter
    this.route.params.subscribe((params) => {
      this.bookingId = params['id'];
      if (this.profile && this.profile.entity && this.profile.entity.id) {
        this.getBookingById();
      } else {
        this.router.navigate(['/']);
      }
    });

    // Configure the Lightbox
    this.lightboxConfig.centerVertically = true;
    this.lightboxConfig.disableScrolling = false;
    this.lightboxConfig.fadeDuration = 0.5;
    this.userEmail = this.appService.getCurrentAccount().email;
    this.getCurrentRole();
  }

  getBookingById() {
    // Fetch the booking details using the bookingId
    this.http.get<any>(`${API_FETCH_BOOKINGS}/${this.bookingId}`).subscribe(
      (booking) => {
        this.booking = booking;
        this.isLoading = false;
        console.log('booking', booking);
        this.calculateTimeDifference();

        // Now fetch the image URLs based on booking data
        if (this.booking.property.images && this.booking.property.images.length > 0) {
          this.imageUrls = this.booking.property.images.map(
            (imagePath) =>
              `${this.baseImageUrl}${imagePath}`
          );

          // Populate the albums array with valid data
          this.imageUrls.forEach((imageUrl) => {
            if (imageUrl) { // Check if imageUrl is defined
              const album: IAlbum = {
                src: imageUrl, // Valid image URL
                caption: '',   // Caption (you can set this if needed)
                thumb: '',     // Thumbnail URL (you can set this if needed)
              };
              this.albums.push(album);
            }
          });
        }
      },
      (error) => {
        this.isLoading = false;
        console.error('Failed to fetch booking:', error);
      }
    );
  }

  // get current user role
  getCurrentRole() {
    this.appService.currentUser.subscribe(currentUser => {
      if (currentUser && currentUser.roles && currentUser.roles.length) {
        currentUser.roles.forEach(ele => {
          this.currentUserRole = ele;
          console.log(this.currentUserRole)
        })
      }
    })
  }

  calculateTimeDifference() {
    if (this.booking && this.booking.property.availableSlots && this.booking.property.availableSlots.length > 0) {
      const { timeFrom, timeTo } = this.booking.property.availableSlots[0];
      if ((timeFrom && timeFrom.length) && (timeTo && timeTo.length)) {
        const hourDifference = timeTo[0] - timeFrom[0];
        const minuteDifference = timeTo[1] - timeFrom[1];

        this.timeDifference = `${hourDifference} h ${minuteDifference} m`;
      }
    } else {
      this.timeDifference = "N/A"; // Set a default value when data is not available
    }
  }

  copyBookingLinkToClipboard(bookingId: string) {
    let copyUrl = null;

    if (environment.api_url === 'https://devapi.hour4u.com') {
      copyUrl = `https://dev.workorbits.com/bookings/view-booking/${bookingId}`;
    }
    if (environment.api_url === 'https://api.hour4u.com') {
      copyUrl = `https://workorbits.com/bookings/view-booking/${bookingId}`;
    }

    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = copyUrl || '';
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    // Update the local state to mark the booking's link as copied
    this.copiedSocieties[bookingId] = true;

    // Reset the button text after a specific duration (e.g., 3 seconds)
    setTimeout(() => {
      this.copiedSocieties[bookingId] = false;
    }, 5000);
  }

  viewUploadedImage(element: any) {
    if (element) {
      const imagePath = element;
      const dialogRef = this.dialog.open(ViewUploadedImageComponent, {
        width: '1024px',
        panelClass: 'add-edit-user-dialog',
        disableClose: true,
        data: {
          imageUrl: imagePath,
          selectedTask: element,
          title: 'View venue picture'
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.ngOnInit();
        }
      });
    } else {
      console.error('Image URL not available.');
    }
  }

  // get Total Billing
  getTotalBilling() {
    let totalBilling = 0;
    if (this.booking && this.booking.quotation && this.booking.quotation.services && this.booking.quotation.services.length) {
      this.booking.quotation.services.forEach(ele => {
        totalBilling = totalBilling + ele.rate;
      })
    }
    return totalBilling;
  }

  // applicable GST
  applicableGST() {
    let totalBilling = 0;
    if (this.booking && this.booking.quotation && this.booking.quotation.services && this.booking.quotation.services.length) {
      this.booking.quotation.services.forEach(ele => {
        totalBilling = totalBilling + ele.rate;
      })
      totalBilling = totalBilling * 0.18
    }
    return totalBilling;
  }

  // get Total Final Billing
  getTotalFinalBilling() {
    let totalBilling = 0;
    if (this.booking && this.booking.quotation && this.booking.quotation.services && this.booking.quotation.services.length) {
      this.booking.quotation.services.forEach(ele => {
        totalBilling = totalBilling + ele.rate;
      })
      totalBilling = totalBilling * 1.18
    }
    return totalBilling;
  }

  // change Application Status
  changeApplicationStatus(status, data) {
    this.http.get(API_BOOKING + '/' + data.id + '/' + status).subscribe(
      (response: any) => {
        if (status == 'APPROVED') {
          this.notify.showMessage("Quotation approved Successfully!", 2000);
          this.payQuote(response);
        } else {
          this.notify.showMessage("Quotation rejected Successfully!", 2000);
        }
        this.getBookingById();
      })
  }

  payQuote(booking) {
    console.log(booking)
    const razorPayOptions = {
      amount: booking.quotation.totalAmount * 100, // Multiplying by 100 to convert to paisa
      currency: 'INR',
      key: environment.rezorpayKey,
      order_id: booking.paymentDetails.razorPayOrderId,
      invoice_id: booking.paymentDetails.razorPayInvoiceId,
      "handler": (paymentResponse: any) => {
        this.notify.showMessage("Payment success and Booking saved. Redirecting to my bookings", 2000);
        this.getBookingById();
        this.router.navigateByUrl(`/bookings/view-booking/${this.bookingId}`)
        // Perform any necessary action upon successful payment here

      },
      "modal": {
        "ondismiss": () => {
          console.log('Payment window dismissed');
          // Handle dismiss scenarios if required
        }
      }
    };

    // Initiate Razorpay payment with the provided options
    const rzp = new Razorpay(razorPayOptions);
    rzp.open();

    rzp.on('payment.failed', function (response: any) {
      // Handle payment failure if required
      console.error('Payment failed:', response);
    });
  }

  // send Quote
  sendQuote(data) {
    console.log(data)
    const dialogRef = this.dialog.open(RequestQuoteComponent, {
      width: '488px',
      panelClass: 'add-edit-user-dialog',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      this.getBookingById();
      this.router.navigateByUrl(`/bookings/view-booking/${this.bookingId}`)
    });
  }

}